import MyTeams from "./MyTeams";
export default MyTeams;